import { fget } from "../../../API/callsAPI";

export const fetchFilterOptionList = async (fieldKey, projectId) => {
  switch (fieldKey) {
    case "allowed_dept": {
      const res = await fget({ url: `/department/?project=${projectId}` });
      return res.data?.results ?? [];
    }
    case "status": {
      const res = await fget({
        url: `/trackables/status/?project=${projectId}`,
      });
      return res.data?.results ?? [];
    }
    case "type": {
      const res = await fget({ url: "/trackables/asset-type-choices/" });
      return res.data?.asset_type_choices ?? [];
    }
    case "task": {
      const res = await fget({ url: `/projects/${projectId}/tasks/` });
      return res.data?.results ?? [];
    }
    default:
      return [];
  }
};